import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage'
import {Http, Response} from "@angular/http";
import {GlobalVariable} from "./global.vars";
import {Observable} from "rxjs/Observable";

@Injectable()
export class AuthService {
  private API_URL = GlobalVariable.API_URL;
  data: any;

  constructor (public http: Http, private storage: Storage) {}

  connect(user): Observable<any>{
      return this.http.post(this.API_URL+"/login", user)
        .map((res:Response)=>{
        this.data = res.json();
        return this.data;
      })
        .catch(this.handleError)
  }

  private handleError(error: any) {
    console.error(error);
    return Observable.throw(error.json().error || 'Server error');
  }

  disconnect(){
      //Clear storage
      return this.storage.clear();
  }

  hasPermission(user, obj, assoc){
    let permissions = user._role.permissions;
    let validated = false;
      for(let permission of permissions){
        let splited = permission.split("_");
        let association = splited[1];
        let object = splited.slice(2,splited.length).join("_");

        if(obj.toUpperCase() === object && assoc.toUpperCase() === association){
          validated = true;
        }
      }

    return validated;
  }

  setAuthData(auth, user, token){
    //store user object and token
    this.storage.ready().then(() => {
      this.storage.set('user', user);
      this.storage.set('token', token);
      this.storage.set('auth', auth)
    });
  }


}



// WEBPACK FOOTER //
// ./src/services/auth.service.ts